// pusher.js
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

window.Pusher = Pusher;

Pusher.logToConsole = false;

let echoInstance = null;

let broadcastEndpoint = process.env.VUE_APP_API_ENDPOINT;

export function createEcho(token) {
    return new Echo({
        broadcaster: 'pusher',
        key: process.env.VUE_APP_PUSHER_APP_KEY,
        cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
        forceTLS: false,
        enabledTransports: ['ws', 'wss'], // Enable WebSocket
        disableStats: true,
        authEndpoint: `http://${broadcastEndpoint}/broadcasting/auth`,
        auth: {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        }
    });
}

export function initEcho(token) {
    echoInstance = createEcho(token);
    window.Echo = echoInstance;
}

export function getEcho() {
    if (!echoInstance) {
        console.error('Echo instance not initialized');
        return null;
    }
    return echoInstance;
}

// Function to listen for an event on a public channel
export function listenForPublicEvent(channelName, eventName, callback) {
    getEcho()
        .channel(channelName)
        .listen(eventName, e => {
            console.log(`Received ${eventName} event on public channel:`, e);
            callback(e);
        });
}

// Function to listen for an event on a private channel
export function listenForPrivateEvent(channelName, eventName, callback) {
    console.log(
        'Attempting to listen for private event:',
        channelName,
        eventName
    );
    const channel = getEcho().private(channelName);
    console.log('Channel object:', channel);
    channel.listen(eventName, e => {
        console.log(`Received ${eventName} event on private channel:`, e);
        callback(e);
    });
    console.log('Listener set up complete');
}

// Function to join a presence channel
export function joinPresenceChannel(channelName, callbacks) {
    console.log('Attempting to join presence channel:', channelName);
    return getEcho()
        .join(channelName)
        .here(users => {
            console.log('Present users:', users);
            if (callbacks.here) callbacks.here(users);
        })
        .joining(user => {
            console.log('User joined:', user);
            if (callbacks.joining) callbacks.joining(user);
        })
        .leaving(user => {
            console.log('User left:', user);
            if (callbacks.leaving) callbacks.leaving(user);
        })
        .listen('.UserStatusUpdated', e => {
            console.log('User status updated:', e);
            if (callbacks.UserStatusUpdated) callbacks.UserStatusUpdated(e);
        });
}

// Function to leave a channel
export function leaveChannel(channelName) {
    getEcho().leave(channelName);
}

export function refreshEcho(token) {
    initEcho(token);
}

// You can add more Pusher-related functions here as needed
